import { useEffect, useRef } from 'react';

export const useOnClickOutside = (ref, handler) => {
	// Keep the latest handler without re-subscribing on every render.
	const handlerRef = useRef(handler);
	useEffect(() => {
		handlerRef.current = handler;
	});

	useEffect(() => {
		const listener = event => {
			if (!ref.current || ref.current.contains(event.target)) return;
			handlerRef.current(event);
		};

		document.addEventListener('mousedown', listener);
		document.addEventListener('touchstart', listener);

		return () => {
			document.removeEventListener('mousedown', listener);
			document.removeEventListener('touchstart', listener);
		};
	}, [ref]);
};
